import { render, staticRenderFns } from "./LeftSideBar.vue?vue&type=template&id=46796b6e&scoped=true"
import script from "./LeftSideBar.vue?vue&type=script&lang=js"
export * from "./LeftSideBar.vue?vue&type=script&lang=js"
import style0 from "./LeftSideBar.vue?vue&type=style&index=0&id=46796b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46796b6e",
  null
  
)

export default component.exports